/* eslint-disable @typescript-eslint/no-explicit-any */
import { FlattenSimpleInterpolation } from 'styled-components';
import { MixinFunction } from '../types';

// we wait for TypeScript 4.0 generic tuples feature in order to simplify this typing
// So we can move last resolver parameter just to one of dep functions
type Func = (...arg: any[]) => any;
export type StyledMixin<ThemeType extends Record<string, unknown>, PropsType = Record<string, unknown>, ReturnType = string> = (
  props: PropsType & { theme: ThemeType }
) => ReturnType;

export function combineValues<V1 extends Func, P extends unknown>(
  v1: V1,
  resolver: (v1: ReturnType<V1>, props: P) => FlattenSimpleInterpolation | string
): StyledMixin<any, P, string>;
export function combineValues<V1 extends Func, V2 extends Func, P extends unknown>(
  v1: V1,
  v2: V2,
  resolver: (v1: ReturnType<V1>, v2: ReturnType<V2>, props: P) => FlattenSimpleInterpolation | string
): StyledMixin<any, P, string>;
export function combineValues<V1 extends Func, V2 extends Func, V3 extends Func, P extends unknown>(
  v1: V1,
  v2: V2,
  v3: V3,
  resolver: (v1: ReturnType<V1>, v2: ReturnType<V2>, v3: ReturnType<V3>, props: P) => FlattenSimpleInterpolation | string
): StyledMixin<any, P, string>;
export function combineValues<V1 extends Func, V2 extends Func, V3 extends Func, V4 extends Func, P extends unknown>(
  v1: V1,
  v2: V2,
  v3: V3,
  v4: V4,
  resolver: (v1: ReturnType<V1>, v2: ReturnType<V2>, v3: ReturnType<V3>, v4: ReturnType<V4>, props: P) => FlattenSimpleInterpolation | string
): StyledMixin<any, P, string>;
export function combineValues<V1 extends Func, V2 extends Func, V3 extends Func, V4 extends Func, V5 extends Func, P extends unknown>(
  v1: V1,
  v2: V2,
  v3: V3,
  v4: V4,
  v5: V5,
  resolver: (
    v1: ReturnType<V1>,
    v2: ReturnType<V2>,
    v3: ReturnType<V3>,
    v4: ReturnType<V4>,
    v5: ReturnType<V5>,
    props: P
  ) => FlattenSimpleInterpolation | string
): StyledMixin<any, P, string>;
export function combineValues<V1 extends Func, V2 extends Func, V3 extends Func, V4 extends Func, V5 extends Func, V6 extends Func, P extends unknown>(
  v1: V1,
  v2: V2,
  v3: V3,
  v4: V4,
  v5: V5,
  v6: V6,
  resolver: (
    v1: ReturnType<V1>,
    v2: ReturnType<V2>,
    v3: ReturnType<V3>,
    v4: ReturnType<V4>,
    v5: ReturnType<V5>,
    v6: ReturnType<V6>,
    props: P
  ) => FlattenSimpleInterpolation | string
): StyledMixin<any, P, string>;

export function combineValues(...args: unknown[]): StyledMixin<any, any, string> {
  const functions = args.slice(0, -1) as MixinFunction[];
  const compute = args[args.length - 1] as MixinFunction;
  return (props) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    const values = functions.map((value) => value(props));
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return compute(...values, props);
  };
}
